/**
 * This file contains all the analytics events that are used in the application.
 */

/**
 * @description Google Analytics events
 * @returns {Record<string, string>} Google Analytics events
 */
export const GOOGLE_ANALYTICS_EVENTS = {};

/**
 * @description PostHog events
 * @returns {Record<string, string>} PostHog events
 */
export const POSTHOG_EVENTS = {};
